import { render, staticRenderFns } from "./flash.vue?vue&type=template&id=16649c20&"
import script from "./flash.vue?vue&type=script&lang=js&"
export * from "./flash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16649c20')) {
      api.createRecord('16649c20', component.options)
    } else {
      api.reload('16649c20', component.options)
    }
    module.hot.accept("./flash.vue?vue&type=template&id=16649c20&", function () {
      api.rerender('16649c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/flash.vue"
export default component.exports